export const FIELD_TYPES = {
  SPECIAL: {
    ad: {
      id: 'ad',
      label: 'label.ADS',
      tooltip: 'label.TOOLTIP.FIELD_TYPES_AD'
    },
    adtag: {
      id: 'adtag',
      label: 'label.AD_TAGS',
      tooltip: 'label.TOOLTIP.FIELD_TYPES_AD_TAGS'
    },
    adtags: {
      id: 'adtags',
      label: 'label.AD_TAGS',
      tooltip: 'label.TOOLTIP.FIELD_TYPES_AD_TAGS'
    },
    doc: {
      id: 'doc',
      label: 'label.DOCUMENTS',
      tooltip: 'label.TOOLTIP.FIELD_TYPES_DOCUMENT.'
    },
    plugin: {
      id: 'plugin',
      label: 'label.PLUGINS',
      tooltip: 'label.TOOLTIP.FIELD_TYPES_PLUGINS'
    },
    vid: {
      id: 'vid',
      label: 'label.VIDEOS',
      tooltip: 'label.TOOLTIP.FIELD_TYPES_VIDEO'
    }
  }
};
